import { all } from "redux-saga/effects";
import Auth from "views/auth-views/login/redux/Sagas";
import Master from "views/app-views/master/redux/Sagas";
import Stock from "views/app-views/master/stock/redux/Sagas";

export default function* rootSaga(getState) {
  yield all([Auth(), Master(), Stock()]);
}
